import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/primitives";
import { BEACON_METHOD } from "@/data/content";

export default function BeaconMethod() {
  return (
    <section className="py-24 md:py-36 border-b hairline" data-testid="beacon-method-section">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="max-w-3xl">
          <Reveal><Overline>03 — The Process</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-heading font-light text-navy tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              The Beacon Method<span className="text-gold align-super text-2xl">™</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg leading-relaxed text-ink/70 max-w-xl font-body">
              We turn fragmented visibility into a deliberate system.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 border-t hairline">
          {BEACON_METHOD.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <div className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 border-b hairline items-baseline hover:bg-mist/60 transition-colors duration-300 -mx-4 px-4">
                <div className="md:col-span-1 font-heading text-gold text-sm tracking-widest">{s.n}</div>
                <div className="md:col-span-3">
                  <h3 className="font-heading font-light text-navy text-2xl md:text-3xl">{s.title}</h3>
                </div>
                <div className="md:col-span-8">
                  <p className="text-ink/70 leading-relaxed font-body md:text-lg">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
